export default __webpack_public_path__ + "static/media/usa5.f6d11353.jpg";